var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        title: _vm.editData.id ? "修改" : "新增",
        visible: _vm.dialogVisible,
        width: "800px",
        "show-close": true,
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form",
              attrs: { model: _vm.form, rules: _vm.rules },
            },
            [
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("label", { staticClass: "lable" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                    _vm._v("类型"),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "portType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.editData.id },
                          model: {
                            value: _vm.form.portType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "portType", $$v)
                            },
                            expression: "form.portType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("空运"),
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("海运"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("label", { staticClass: "lable" }, [_vm._v("港口类型")]),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "types" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.form.types,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "types", $$v)
                            },
                            expression: "form.types",
                          },
                        },
                        [
                          _c("el-checkbox", { attrs: { label: 0 } }, [
                            _vm._v("始发港"),
                          ]),
                          _c("el-checkbox", { attrs: { label: 1 } }, [
                            _vm._v("目的港"),
                          ]),
                          _c("el-checkbox", { attrs: { label: 2 } }, [
                            _vm._v("清关港"),
                          ]),
                          _c("el-checkbox", { attrs: { label: 3 } }, [
                            _vm._v("卸货港"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("label", { staticClass: "lable" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                    _vm._v("代码"),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "code" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "320px" },
                        attrs: { placeholder: "请输入代码" },
                        model: {
                          value: _vm.form.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "code", $$v)
                          },
                          expression: "form.code",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("label", { staticClass: "lable" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                    _vm._v("中文名称"),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "nameCH" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "320px" },
                        attrs: { placeholder: "请输入备注内容" },
                        model: {
                          value: _vm.form.nameCH,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "nameCH", $$v)
                          },
                          expression: "form.nameCH",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("label", { staticClass: "lable" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                    _vm._v("英文名称"),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "nameEN" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "320px" },
                        attrs: { placeholder: "请输入备注内容" },
                        model: {
                          value: _vm.form.nameEN,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "nameEN", $$v)
                          },
                          expression: "form.nameEN",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("label", { staticClass: "lable" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                    _vm._v("地址"),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "address" } },
                    [
                      _c("el-cascader", {
                        ref: "myCascader",
                        staticStyle: { width: "320px" },
                        attrs: {
                          placeholder: "请选择地址",
                          options: _vm.addressDropCodeOption,
                        },
                        model: {
                          value: _vm.form.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "address", $$v)
                          },
                          expression: "form.address",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "form-item",
                  staticStyle: { width: "100%", "margin-left": "0" },
                },
                [
                  _c("label", { staticClass: "lable" }, [_vm._v("备注")]),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "remark" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "660px" },
                        attrs: { placeholder: "请输入备注内容" },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取 消")]
          ),
          _c(
            "div",
            {
              staticClass: "ok flex_c_c",
              on: {
                click: function ($event) {
                  return _vm.ok("form")
                },
              },
            },
            [_vm._v("确 定")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }